// extracted by mini-css-extract-plugin
module.exports = {"block":"Profile_block__39hnY","root":"Profile_root__2yrMH","buttons":"Profile_buttons__1aBo2","link":"Profile_link__2l68k"};